import React from 'react';
import { StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import Theme from 'Theme/index';
import type { StyleMap } from 'Types';

const defaultStyles = StyleSheet.create({
    duration: {
        fontFamily: Theme.regularFont,
        color: Theme.secondaryTextColor,
        fontSize: 22
    }
});

interface DurationProps {
    value: string;
    style?: StyleMap | StyleMap[];
    onPress: () => void;
}

const Duration = ({ value, style, onPress }: DurationProps): JSX.Element => (
    <Text style={[defaultStyles.duration, style]} onPress={onPress}>
        {value}
    </Text>
);

export default Duration;
